module.exports = __webpack_public_path__ + "static/media/landing_image_medical_procedure.70682f1a.jpg";